
import { defineComponent, computed, ref, inject } from "vue";
//import { useRouter } from "vue-router";
import filiation from "@/filiation/composables/useFiliation";
import formatDate from "@/helpers/formatDate";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
export default defineComponent({
  name: "Check-reentry",
  components: {},
  setup() {
    //const router = useRouter();
    const {
      checkDataAlreadyExist,
      getPersonalData,
      documentType,
      // getPosibleOrder,
      registerReentry,
      // kardex,
    } = filiation();
    const getNameDocumentTypes = async (value: string) => {
      if (value) {
        const { data } = await documentType();
        const found = await data.find(
          (element: any) => element.id_tipo_documento_identidad === value
        );
        const respuesta = found.nombre_tipo_documento_identidad;
        return respuesta;
      }
    };
    const numero_documento = ref("");
    const fotografia = ref("");
    const nombres = ref("");
    const primerApellido = ref("");
    const segundoApellido = ref("");
    const fechaNacimiento = ref("");
    const lugarNacimientoPais = ref("");
    const tipoDocumento = ref("");
    //const esReingreso = ref(false);
    const formData = ref([]);
    const emitter: any = inject("emitter");
    emitter.on("checkIfExist", async (value: any) => {
      // *Listen* for event
      if (value) {
        const datos = computed(() => getPersonalData.value);
        numero_documento.value = datos.value.personalData.numero_documento;
        nombres.value = datos.value.personalData.nombres;
        primerApellido.value = datos.value.personalData.primerApellido;
        segundoApellido.value = datos.value.personalData.segundoApellido;
        fechaNacimiento.value = datos.value.personalData.fechaNacimiento;
        fotografia.value = datos.value.personalData.fotografia;
        tipoDocumento.value = datos.value.personalData.tipo_documento;
        lugarNacimientoPais.value = datos.value.personalData.lugarNacimientoPais;
        const { data } = await checkDataAlreadyExist({ datos });       
        if (data === null) {
          return;
          // console.log("no tiene coincidencias");
        } else {
          formData.value = data.result;
        }
        tipoDocumento.value = await getNameDocumentTypes(tipoDocumento.value);
      }
    });
    const newReentry = async (id: number) => {
      Swal.fire({
        title: `¿Está segura/o de registrar el reingreso de ${nombres.value.toUpperCase()} ${primerApellido.value.toUpperCase()} ${segundoApellido.value.toUpperCase()}?`,
        text: "Esta acción no podrá ser revertida",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, registrar",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
      }).then(async (result: any) => {
        if (result.isConfirmed) {
          const { data } = await registerReentry(id);
          if (data.ok) {
            Swal.fire(
              "¡Registrado!",
              `Continuar con el registro del reingreso de ${nombres.value.toUpperCase()} ${primerApellido.value.toUpperCase()} ${segundoApellido.value.toUpperCase()}`,
              "success"
            );
          }
        }
      });
    };
    return {
      numero_documento,
      fotografia,
      nombres,
      primerApellido,
      segundoApellido,
      fechaNacimiento,
      lugarNacimientoPais,
      tipoDocumento,
      formData,
      //dataToCheck,
      formatDate,
      getNameDocumentTypes,
      newReentry,
    };
  },
});
